export const Card = ({ title, description, Icon }) => {
    return (
        <div className=" px-2 py-4">
            {Icon && <Icon className="h-10" />}
            <h4 className="text-2xl font-bold text-primary">{title}</h4>
            <p>{description}</p>
        </div>
    );
}